<template>
  <div class="container page lottery">
    <van-nav-bar title="认证窗口" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
      <template #right>
        <van-icon name="arrow-down" color="#333" @click="showLotteryChanceBox=true" />
        <!-- {{ lottery.name }} -->
        <!-- <div class="c_kk_u_m">{{ this.userInfo.money }}</div> -->
        <!-- <div class="right" @click="showRight">{{ $t('reservation.switching_window') }}</div>  -->
        <!-- <div class="right c_k_right" @click="showRight" v-if="userInfo.money">{{ userInfo.money }}</div>
        <img :src="lottery.ico" v-if="lottery.ico" class="c_kk_img" @click="toMine">
        <img src="../../../public/img/neww/userpic.png" class="c_kk_img" v-if="!lottery.ico" @click="toMine"> -->
      </template>
    </van-nav-bar>
      <div class="vw_black" @click="$refs.noticeDetailPop.show(noticeNew)">
          <van-notice-bar color="#ff4d67" background="#fff" left-icon="volume-o" :text="noticeNew.name||'欢迎使用'" />
      </div>
      
    <div class="lotteryMainTab">
      <div class="left">
        <div class="tabItem active">
          我要认证
        </div>
        <div class="tabItem">
          最近认证
        </div> <!---->
      </div>
      <div class="right">
        <div class="tabItem balance">
          <div>
            <p @click="showMoney=!showMoney" style="color: rgb(255, 77, 103);">
              {{ showMoney?`￥ ${userInfo.money}`:'积分' }}
            </p> 
          </div>
        </div>
      </div>
    </div>
    <div class="lotteryMsgBox">
      <div class="lotteryMsg">
        <div class="top">
          <div class="time">
            <p style="">{{ lottery.now_expect }}期</p>
            <p style="display: none;">距离下一期</p>
            <van-count-down v-if="lottery.now_expect" class="count_down" format="HH:mm:ss" :time="time" @finish="check()" />
          </div>
        </div>
        <div class="ks openInfo" @click="active ? active = false : active = true">
          <div class="foot">
            <div>
              <div class="periods">
                {{prevLotteryInfo.expect}}期认证结果
                <svg :class="{ up: active, down: !active }" type="ios-arrow-down" size="13" xmlns="http://www.w3.org/2000/svg" width="13"
                  height="13" viewBox="0 0 512 512" class="vux-x-icon vux-x-icon-ios-arrow-down">
                  <path d="M396.6 160l19.4 20.7L256 352 96 180.7l19.3-20.7L256 310.5z"></path>
                </svg>
              </div>
              <div class="lotteryResult"><span>{{ prevLotteryInfo.size }} </span><span
                >{{ prevLotteryInfo.double }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hr"></div>
    <div class="history_popup"></div>
    <div class="wrapper">
      <div class="options-bar">
        <div class="put_tit_r">实时投票</div>
        <div class="game">
          <div class="sumValueTwoSides">
            <div class="rectangle large" :class="{ active: choose[v.type] }" v-for="(v, key) in lottery_peilv_list"
              :key="key" @click="choosePlay(v.type, v.name)">
              <div class="c_u_item" :style="{ 'background': v.color }">
                <!-- <img :src="v.img" alt=""> -->
                <div class="text_k">{{ v.name == 'big' ? rose : v.name == 'small' ? lily : v.name == 'one' ? fireworks : balloon }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <winList></winList>
      <div class="winListImg"><img src="/img/717.aa8d730.png" alt=""></div>
      <div style="height: 120px;"></div>
      <div class="creditFooter" style="">
        <div class="setting">
          <div class="setMoney">
            <van-field class="keyboardInput" v-model="money" type="digit"  />
            <p style="border: 1px solid rgb(172, 98, 204);">
              积分
            </p>
          </div>
        </div>
        <div class="btnGroup" style="background: rgb(172, 98, 204) !important; color: rgb(255, 255, 255) !important;">
          <div class="clearBtn" @click="allClear">清除</div>
          <div class="notes">
            <p>共
              <strong>{{ convertedShopchoose!='未选中'?convertedShopchoose.split(',').length:0 }}</strong><span>票</span> <br>
              共
              <strong>{{ convertedShopchoose!='未选中'?convertedShopchoose.split(',').length*(money||0):0 }}</strong>积分
            </p>
          </div>
          <div @click="jiesuan()" class="bettingBtn btn"
            style="background: rgb(172, 98, 204) !important; color: rgb(255, 255, 255) !important;">确认下单</div>
        </div>
      </div>
      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal">
          <!-- <div class="head van-hairline--bottom">
            <p class="text">{{ $t("reservation.task_list") }}</p>
          </div> -->
          <ul class="list">
            <li v-for="(v, key) in formData" :key="key" class="lise-item van-hairline--bottom">
              <div class="main">
                <p class="bet-name">{{ v.name == 'big' ? rose : v.name == 'small' ? lily : v.name == 'one' ? fireworks : balloon }}</p>
                <p class="detail-text">
                  1{{ $t("reservation.note") }}X{{ money
                  }}{{ $t("reservation.unit") }}={{ money
                  }}
                </p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close" />
            </li>
          </ul>
          <div class="sub-bar">
            <van-button class="item cancel-btn" type="default" @click="allClear()">{{ $t("reservation.clear_order")
              }}</van-button>
            <van-button class="item sub-btn" type="default" @click="doSub">{{
              $t("reservation.submit")
            }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '70%' }">
        <div style="height: 100%;display: flex;flex-direction: column;">
          <van-pull-refresh style="height:100%" v-model="isLoading" @refresh="onRefresh">
            <div style="height: 100%;" class="wrapper pop_wrapper">
              <!-- <div class="item">
                <div class="left font-weight">{{ $t("reservation.num") }}</div>
                <div class="right font-weight">
                  {{ $t("reservation.win_num") }}
                </div>
              </div> -->
              <div class="item" v-for="(v, key) in lottery_list" :key="key">
                <div class="left">{{ v.expect }}</div>
                <div class="right font-weight">
                  <div class="kuaisan-ball left">

                    <span class="ballBox">{{ v.opencode[0] }}</span>
                    <span class="ballBox">{{ v.opencode[1] }}</span>
                    <span class="ballBox" style="margin-right: 20px;">{{ v.opencode[2] }}</span>


                    <span class="res-des ">{{
                      v.opencode[0] + v.opencode[1] + v.opencode[2]
                    }}</span>
                    <span class=" middle"
                      :class="calcBgLs(v.opencode[0], v.opencode[1], v.opencode[2], 'type1')">{{ (v.opencode[0] +
                        v.opencode[1] +
                        v.opencode[2]) >= 11 && (v.opencode[0] + v.opencode[1] + v.opencode[2]) &lt;= 18 ? rose :lily
                      }}</span>
                    <span class=" middle" :class="calcBgLs(v.opencode[0], v.opencode[1], v.opencode[2], 'type2')">{{
                      (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0
                        ? balloon
                        : fireworks
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-pull-refresh>
          <div class="goHistory" style="height: 50px;padding: 10px 0;"><div @click="$router.push('/resultsDetails')" style="margin: auto;width: 45%;line-height: 30px;text-align: center;background: #ecebe6;border-radius: 15px;">查看更多</div></div>
        </div>
      </van-popup>

    </div>
    <van-popup v-model="showModel" position="right" :style="{ width: '70%', height: '100%' }">
      <div class="list">
        <div class="item" v-for="(i, index) in gameitemData" :key="index" @click="tabList(i.id, i.key)">
          <div>{{$t("q29")}}</div>
          <div style="margin: 15px 0 0 15px;">
            <div style="height: 86px;background-color: #fff;width: 60px;display: flex;align-items: center;border-radius: 8px;">
              <van-image width="60" height="61" :src="i.ico" style="" />
            </div>
            <div style="font-size: 14px;">{{ i.name }}</div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showLotteryChanceBox" position="top" :style="{ width: '100%', height: '100%' }">
      <van-nav-bar title="认证窗口" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#333" @click="back()" />
        </template>
        <template #right>
          <van-icon name="arrow-down" color="#333" @click="showLotteryChanceBox=false" />
        </template>
      </van-nav-bar>
        <div class="lotteryChanceBoxlist">
          <div class="title">
            <div class="iconBox"><img src="/img/jiaofu.png" alt=""></div>
            <p>交付</p>
          </div>
          <div class="infoBox">
            <div class="item">
              <div class="itemInfo active">
                认证窗口
              </div>
            </div>
          </div>
        </div>
    </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;
import winList from './winList.vue';
export default {
  components:{winList},
  data() {
    return {
      showLotteryChanceBox:false,
      noticeNew:{},
      showMoney:false,

      jiesuanpage: false,
      showModel: false,
      rose: '',
      lily: '',
      balloon: "",
      fireworks: "",
      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: [],
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      ids: 11,
      keys: 5,
      gameitemData: [],
      userTimer:"",
      prevLotteryInfo: {
        expect: '', // 上一期期号
        size: '',   // 上一期大小
        double: ''  // 上一期单双
      }
    };
  },
  mounted(){
    this.$http({
        method: 'get',
        url: 'getNoticeNew'
    }).then(res=>{
      if(res.code==200){
        this.noticeNew=res.data
      }
    })
    if(this.userTimer){
      clearInterval(this.userTimer);
      this.userTimer = ""
    }
    setInterval(()=>{
      this.getUserInfo()
    },10000)
  },
  methods: {
    reset() {
      this.formData=[]
      this.choose.big=false
      this.choose.small=false
      this.choose.two=false
      this.choose.one=false
      this.shopchoose=''
    },
    toMine() {
      this.$router.push("/Mine")
    },
    back() {
      return window.history.back();
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.doSub()
        // this.jiesuanpage
        //   ? (this.jiesuanpage = false)
        //   : (this.jiesuanpage = true);
      }
    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      console.log(type, name);
      console.log(this.choose)
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
        console.log(this.shopchoose, 'ssss')
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          console.log(this.userInfo,"---477")
          if(this.userInfo.is_online != 1){
            localStorage.clear()
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          let lottery_peilv_list = res.data;
          console.log(lottery_peilv_list, "lottery_peilv_list--508")
          let clist = [];
          let appItem = [
            { img: "/img/neww/huojian.gif", color: "#8948fb" },
            { img: "/img/neww/fly.gif", color: "#ff6398" },
            { img: "/img/neww/youting.gif", color: "#2196f3" },
            { img: "/img/neww/cat.gif", color: "#ff7d73" },
          ]
          lottery_peilv_list.map((itemc, key) => {
            itemc = {
              ...itemc,
              ...appItem[key]
            }
            clist.push(itemc)
          })
          this.lottery_peilv_list = clist;

          console.log("lottery_peilv_list:", this.lottery_peilv_list);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          // 获取当前期号
          const currentExpect = this.lottery.now_expect;
          
          // 过滤逻辑
          const filteredList = res.data.filter(item => {
            // 条件1：期号不是当前期号
            if (item.expect === currentExpect) {
              return false;
            }
            
            // 条件2：开奖号码有效（不是0,0,0）
            const sum = item.opencode[0] + item.opencode[1] + item.opencode[2];
            if (sum === 0) {
              return false;
            }
            
            // 条件3：开奖号码在有效范围内（根据你的游戏规则）
            const minNumber = 1;
            const maxNumber = 6;
            
            const isValidNumber = item.opencode.every(num => 
              num >= minNumber && num <= maxNumber
            );
            
            return isValidNumber;
          });
          
          this.lottery_list = filteredList;
          
          // 获取上一期信息（列表中的第一条）
          if (filteredList.length > 0) {
            this.updatePrevLotteryInfo(filteredList[0]);
          }
          
          console.log("过滤后的 lottery_list:");
          console.log(this.lottery_list);
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    // 更新上一期开奖信息
    updatePrevLotteryInfo(prevItem) {
      const lang = 'zh'; // 根据实际语言设置调整
      const prevSum = prevItem.opencode[0] + prevItem.opencode[1] + prevItem.opencode[2];
      
      let size = '';
      let double = '';
      
      // 计算大小
      if (prevSum >= 11 && prevSum <= 18) {
        if (lang === 'zh') size = '火箭';
        else if (lang === 'en') size = 'Rose';
        else if (lang === 'ja') size = 'ロケット';
        else size = '장미';
      } else if (prevSum >= 3 && prevSum <= 10) {
        if (lang === 'zh') size = '飛機';
        else if (lang === 'en') size = 'Lily';
        else if (lang === 'ja') size = 'ハート';
        else size = '백합';
      }
      
      // 计算单双
      if (prevSum % 2 === 0) {
        if (lang === 'zh') double = '跑車';
        else if (lang === 'en') double = 'Balloon';
        else if (lang === 'ja') double = 'バラ';
        else double = '풍선';
      } else {
        if (lang === 'zh') double = '游艇';
        else if (lang === 'en') double = 'Fireworks';
        else if (lang === 'ja') double = 'ヨット';
        else double = '불꽃놀이';
      }
      
      this.prevLotteryInfo = {
        expect: prevItem.expect,
        size: size,
        double: double
      };
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitemData = res.data;
        console.log(this.gameitemData, 'gameitemData')
      })
    },
    tabList(id, key) {
      this.ids = id
      this.keys = key
      this.showModel = false
      this.getUserInfo();
      this.getGameItem()
      this.getLotteryInfo();
      this.getLotteryList();
    },
    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        // 获取当前语言设置
        const currentLang = localStorage.getItem('lang') || 'zh';
        console.log(currentLang, "currentLang---552");
        
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }
          
          this.lottery = res.data;
          console.log(this.lottery, 'qweqweqw');
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t("reservation.prize_succ") + this.lottery.now_expect);
          }
          
          // 这里计算当前期的 sum、size、double，用于其他可能需要的地方
          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
          console.log(this.sum, 'sum');
          
          // 根据当前语言设置 size 和 double 的值
          if (this.sum >= 11 && this.sum <= 18) {
            if (currentLang === 'zh') this.size = '火箭';
            else if (currentLang === 'en') this.size = 'Rose';
            else if (currentLang === 'ja') this.size = 'ロケット';
            else this.size = '장미';
          } else if (this.sum >= 3 && this.sum <= 10) {
            if (currentLang === 'zh') this.size = '飛機';
            else if (currentLang === 'en') this.size = 'Lily';
            else if (currentLang === 'ja') this.size = "ハート";
            else this.size = '백합';
          }
          
          if (this.sum % 2 === 0) {
            if (currentLang === 'zh') this.double = "跑車";
            else if (currentLang === 'en') this.double = "Balloon";
            else if (currentLang === 'ja') this.double = "バラ";
            else this.double = "풍선";
          } else {
            if (currentLang === 'zh') this.double = "游艇";
            else if (currentLang === 'en') this.double = "Fireworks";
            else if (currentLang === 'ja') this.double = "ヨット";
            else this.double = "불꽃놀이";
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        console.log(this.lottery, 9900);
      });
    },
    calcBg(el) {
      if (el == '火箭' || el == 'Rose' || el == 'ロケット' || el == '장미') {
        return 'd'
      } else if (el == '飛機' || el == 'Lily' || el == "ハート" || el == '백합') {
        return 'x'
      } else if (el == "游艇" || el == "Fireworks" || el == "ヨット" || el == "불꽃놀이") {
        return 'v'
      } else if (el == "跑車" || el == "Balloon" || el == "バラ" || el == "풍선") {
        return 'r'
      } else {
        return 'r'
      }
    },
    calcBgLs(n1, n2, n3, type) {
      let zhi = n1 + n2 + n3;
      if (type == 'type1') {
        if (zhi >= 11 && zhi < 18) {
          return 'd'
        } else {
          return 'x'
        }
      }
      if (type == 'type2') {
        if (zhi % 2 == 0) {
          return 'v'
        } else {
          return 'r'
        }
      }
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    }
    
    // 根据当前语言设置初始值
    const currentLang = localStorage.getItem('lang') || 'zh';
    if (currentLang == 'zh') {
      this.rose = '火箭';
      this.lily = '飛機';
      this.balloon = '跑車';
      this.fireworks = '游艇';
    } else if (currentLang == 'en') {
      this.rose = 'Rose';
      this.lily = 'Lily';
      this.balloon = 'Balloon';
      this.fireworks = 'Fireworks';
    } else if (currentLang == 'ja') {
      this.rose = 'ロケット';
      this.lily = 'ハート';
      this.balloon = 'バラ';
      this.fireworks = 'ヨット';
    } else {
      this.rose = '장미';
      this.lily = '백합';
      this.balloon = '풍선';
      this.fireworks = '불꽃놀이';
    }
  },
  computed: {
    convertedShopchoose() {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };
      return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
    }
  },
  destroyed() {
    clearInterval(time);
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/base.css";
.creditFooter{
      position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    .setting {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    background: #fff;
    height: 80px;
    border-top: 2px solid #e6e6e6;
    border-bottom: 2px solid #e6e6e6;
    .setMoney {
    margin-left: 20px;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    font-size: 26px;
    .keyboardInput {
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border: 2px solid #c5c5c1;
    border-radius: 6px;
    padding: 0 6px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    background-color: #fff;
    color: #333;
}
 p {
    margin-left: 12px;
    width: 90px;
    height: 60px;
    line-height: 64px;
    text-align: center;
    border-radius: 10px;
    color: #000;
    border: 1px solid rgb(172, 98, 204);
    position: relative;
}
}
}
.btnGroup {
    height: 120px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    background: #FF5C74;
    color: #f7f7f7;
    font-size: 30px;
    text-align: center;
    background: rgb(172, 98, 204) !important;
    color: rgb(255, 255, 255) !important;
    .clearBtn {
    margin-left: 20px;
    min-width: 110px;
    height: 60px;
    line-height: 60px;
    border: 2px solid #fff;
    border-radius: 6px;
    padding: 0 6px;
}
.bettingBtn {
    background: -webkit-linear-gradient(left, #ff7186 0%, #ff556e 100%);
    background: linear-gradient(to right, #ff7186 0%, #ff556e 100%);
    height: 120px;
    line-height: 120px;
    width: 200px;
    font-weight: 700;
    background: rgb(172, 98, 204) !important;
    color: rgb(255, 255, 255) !important;
}
.notes {
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    flex-grow: 1;
    padding: 0 24px;
}
}
}
.hr{
  height:180px;
}
.lotteryMsgBox {
  position: absolute;
  top: 236px;
  left: 0;
  z-index: 100;
  width: 100%;

  .lotteryMsg {
    position: relative;
    z-index: 3;
    background: #f7f7f7;
    width: 100%;
    height: 124px;
    font-size: 26px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-shadow: 0 2px 10px #dfdfdf;

    .top {
      height: 124px;
      width: 50%;
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      -webkit-flex-shrink: 0;
      flex-shrink: 0;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      box-sizing: border-box;
      text-align: center;
      border-right: 2px solid #e6e6e6;

      .time {
        font-size: 24px;
        color: #333;
        .count_down{
          color: #ff4d67;
          font-size: 44px;
          line-height: 50px;
          border-width: 0;
          padding: 0;
          border-radius: 0;
          margin-top: 4px;
          float: inherit;
        }
      }
    }

    .openInfo {
      width: 100%;
      height: 124px;
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      font-size: 24px;
      color: #333;

      .foot {
        text-align: center;

        >div {
          width: 100%;
        }
      }
    }
  }
}

.lotteryMainTab{
  position: absolute;
    height: 80px;
    box-sizing: border-box;
    top: 156px;
    left: 0;
    z-index: 101;
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-around;
    justify-content: space-around;
    -webkit-box-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
    font-size: 28px;
    color: #FF5C74;
    background: #fffefe;
.left, .right {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-around;
    justify-content: space-around;
    -webkit-box-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}
    .left {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}
 .right {
    width: 35%;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    box-sizing: border-box;
    padding-right: 30px;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}
.tabItem {
    line-height: 64px;
    height: 64px;
    box-sizing: border-box;
    &.active {
    border-bottom: 6px solid #fff;
    color: #fff;
}
}
    
}
.lotteryChanceBoxlist{
  padding: 20px;
    border-bottom: 2px solid #eee;
    .title {
    line-height: 70px;
    padding-left: 10px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    .iconBox {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    margin-right: 10px;
    width: 42px;
    height: 42px;
    border: 2px solid #FF5C74;
    border-radius: 50%;
     img {
    width: 34px;
    height: 34px;
}
}
}
.infoBox {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    .item {
    width: calc(33.33333333%);
    padding: 0 10px;
    margin-bottom: 12px;
    box-sizing: border-box;
    text-align: center;
    .itemInfo {
    width: 100%;
    background: #eee;
    border-radius: 36px;
    line-height: 72px;
    box-sizing: border-box;
}
    .active {
    border: 2px solid #FF5C74;
    color: #FF5C74;
    background: #fff3f3;
}
}
}
}
.c_kk_img {
  height: 56px;
  width: 56px;
  border-radius: 50%;
  border: 2px solid #766350;
  margin-left: 20px;
}

.info_c_h {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  color: #fff;
  padding: 60px 30px 10px;

  .m1 {
    padding-bottom: 16px;
  }

  .p_number {
    padding-bottom: 10px;
    font-size: 30px;
    span {
      font-weight: bold;
      font-size: 36px;
    }
  }
}

.c_bt_m {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 60px 10px 0 30px;

  .left_b {
    display: inline-flex;
    align-items: center;
    color: #fff;
    .hao{
      font-size: 24px;
    }
    .bn {
      padding: 0 10px;
      border-radius: 30px;
      margin-left: 10px;
      font-size: 20px;

      &.d {
        background: #8948fb;
      }

      &.x {
        background: #ff6398;
      }

      &.v {
        background: #2196f3;
      }

      &.r {
        background: #ff7d73;
      }
    }
  }

  .right_b {
    display: inline-flex;
    align-items: center;

    .r_c {
      font-size: 24px;
      margin-right: 6px;
      color: #fff;
    }
    .up,.down{
      font-size: 28px;
    }
  }
}

.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #e6b98a;
  font-size: 36px;
  border-radius: 10px;

  line-height: 60px;
}

.lottery {
  background: #fff;
  background-size: 94% auto;
  background-position: center 120px;
}

.lottery .van-nav-bar {
  background: #fff;
}

.van-count-down {
  color: #fff;
  font-size: 28px;
  margin-top: 10px;
  float: right;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 6px;
}

.linear-gradient {
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));

}

.record .recent {
  display: flex;
  align-items: center;
  height: 110px;
}

.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}

.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}

.kuaisan-ball .res-des.middle {
  width: 15%;
  font-size: 35px;
}

.van-icon {
  font-size: 40px;
}

.down {
  transition: all 0.5s;
  color: #fff;
}

.up {
  transform: rotate(180deg);
  transition: all 0.5s;
  color: #fff;
}

.wrapper {
  position: relative;
  flex: 1;
  overflow: auto;
  padding-top: 40px;
}

.options-bar {
      margin: 0.3125rem 0.375rem;
    border: 0.0625rem solid #e6e6e6;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    background: #fff;
}

.winListImg {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    margin-top: 0.625rem;
    img{
      width: 100%;
      height: 100%;
    }
}
.put_tit_r {
    font-size: 0.875rem;
    margin-right: 0;
    color: #5c5c5c;
    font-weight: bold;
    height: 1.625rem;
    line-height: 1.625rem;
    text-align: center;
    border-bottom: 0.0625rem solid #e6e6e6;
    background: #f7f7f7;
}

.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.options-bar .game .tips {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.options-bar .game .tips .odds {
  flex: 1;
  font-size: 35px;
  font-weight: 500;
  color: #ff253f;
}

.options-bar .game .tips .play-tip {
  display: flex;
  align-items: center;
  height: 100%;
}

::v-deep .van-icon-more-o {
  color: #ff253f;
  font-size: 50px;
}

.options-bar .game .tips .play-tip .span-text {
  margin-left: 10px;
  font-size: 35px;
  font-weight: bolder;
  color: #ff253f;
}

.linear-gradient {
  width: 100%;
  height: 2px;
}

.sumValueTwoSides {
  display: flex;
  padding: 10px 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  .c_u_item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 40px 20px 10px;
    border: 4px solid transparent;

    img {
      width: 130px;

    }
  }
}

.rectangle {
  overflow: hidden;
}

.rectangle.large {
  width: calc(50% - 4vw) !important;
  // height: 21vw !important;
  // line-height: 21vw;
  text-align: center;
  background: #fff;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, .1);
  margin: 0 0 8px 20px;
  width: 20%;
  border-radius: 20px;
  color: #fff;

  &.active {
    position: relative;

    &::after {
      content: "";
      background: url(/img/neww/ico_yes.png) 100% 100% no-repeat;
      background-size: 50px auto;
      width: 60px;
      height: 60px;
      position: absolute;
      bottom: 2px;
      right: 2px;
      display: block;
    }

    .c_u_item {
      background-color: #212121 !important;
      color: #f3c7a2 !important;
      box-sizing: border-box;
      border: 4px solid #766350;


      /* border: solid 2px #ff4d67; */



    }
  }
}

.rectangle .wrapper {
  position: relative;
  padding: 0 10px;
  background: #fff;
}

.rectangle .wrapper .content {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.pop_wrapper {
  border: solid 1px #ffc3cb;
  margin: 16px;
  padding: 0 10px;

  .item {
    border-bottom: 1px solid #ccc;
  }
}

.rectangle.large .wrapper {
  padding-bottom: 100%;
}

.rectangle .wrapper .content .name-text.large {
  font-size: 32px;
}

.rectangle .wrapper .content .name-text {
  color: #7d7c7c;

}

.rectangle .wrapper .content .odd-text.large {
  font-size: 25px;
  margin-top: -30px;
}

.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: #ff253f;
}

.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 100px;
  z-index: 2;
}

.rectangle.active .wrapper {
  background-color: #ff253f !important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-popup {
  position: absolute;
}

::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}

::v-deep .van-popup--top {
  top: -1px;
}

.wrapper .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}

.wrapper .item .left {
  width: 30%;
  font-size: 30px;
  text-align: center;
  font-weight: 500;
  color: #000;
}

.font-weight {
  font-weight: 700 !important;
}

.wrapper .item .right {
  flex: 1;
  display: flex;
  font-size: 30px;
  justify-content: center;
  overflow: hidden;
  color: #000;
}

.wrapper .item .kuaisan-ball .left {
  justify-content: flex-start;
}

.wrapper .item .kuaisan-ball {
  margin-left: 20px;
  flex: 1;
  display: flex;
  align-items: center;
}

.wrapper .item .kuaisan-ball .res-img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}

.wrapper .item .kuaisan-ball .res-des {
  // background: linear-gradient(90deg, #f560cd, #4f2b8a);
  border: 1px solid #e6b98a;
  color: #e6b98a;
  height: 6vw;
  line-height: 5.5vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
  margin-right: 30px;
  width: 6vw;
  border-radius: 50%;
  flex-shrink: 0;
}

.middle {
  border-radius: 16px;
  padding: 0 16px;
  // background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  height: 6vw;
  line-height: 6vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
  margin-right: 30px;

  &.d {
    background: #8948fb;
  }

  &.x {
    background: #ff6398;
  }

  &.v {
    background: #2196f3;
  }

  &.r {
    background: #ff7d73;
  }
}

.play-type-tip {
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 700px;
  max-height: 50%;
  z-index: 10;
  border-radius: 30px;
  overflow: hidden;
  background-color: #fff;
  color: #000;
}

.play-type-tip .title {
  line-height: 90px;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: 500;
}

.mask {
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}

.play-type-tip .wrapper {
  height: calc(100% - 10px);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.play-type-tip .wrapper .item {
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
}

.play-type-tip .wrapper .item .van-icon {
  color: #e6c3a1;
  font-size: 60px;
}

.play-type-tip .wrapper .item .content .content-title {
  margin-top: 22px;
  font-size: 35px;
  font-weight: 500;
  color: #000;
  line-height: 0px;
}

.play-type-tip .wrapper .item .content .content-detail {
  margin-top: 5px;
  font-size: 22px;
  color: #000;
  line-height: 30px;
}

.play-type-tip .wrapper .item .content {
  flex: 1;
  margin-left: 30px;
}

.rectangle.active .wrapper {
  background-color: #d07ac7 !important;
}

.rectangle.active .wrapper .name-text,
.rectangle.active .wrapper .odd-text {
  color: #fff !important;
}

.van-cell {
  font-size: 30px;
  line-height: 50px;
  background-color: rgba(0, 0, 0, .5);
  margin-left: 20px;
}

::v-deep .van-field__control {
  color: #e6b98a;
}

.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 30px;
}

.confirm-order-modal .head {
  position: relative;
  height: 80px;
}

.confirm-order-modal .head .text {
  padding: 0 20px;
  height: 30px;
  line-height: 10px;
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  color: #7e5678;
}

::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 2px;
}

.van-popup--center {
  border-radius: 30px;
}

.confirm-order-modal .list {
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}

.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}

.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: 35px;
  font-weight: 500;
  // line-height: 0px;
  word-wrap: break-word;
  word-break: break-all;
}

.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 0px;
  font-size: 25px;
  color: #979799;
}

.confirm-order-modal .list .lise-item {
  color: #ff253f;
}

.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}

.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}

.confirm-order-modal .sub-bar .item.cancel-btn {
  border: 2px solid #979799;
  color: #979799;
  background-color: #fff;
}

.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(20deg, #8673e5, #d958a4);
  color: #fff;
  border: 0;
}

.next-number span {
  font-size: 35px;
  font-weight: 700;
  color: #000;
  float: right;
}

.numberBox .resBox {
  display: flex;
  align-items: center;
  // background: #fff;
  border-radius: 16px;
  padding: 16px;
  height: 100%;
  margin-left: 10px;
  width: calc(100% - 37vw);
  box-sizing: border-box;
}

.resBox .resItem {
  width: 9vw;
  height: 9vw;
  line-height: 9vw;
  margin-right: 20px;
  background: linear-gradient(90deg, #8b73e6, #d75db4);
  border-radius: 50%;
  color: #fff;
  text-align: center
}

.ressquareBox {
  border-radius: 16px;
  padding: 0 16px;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  height: 7vw;
  line-height: 7vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
}

.ballBox {
  color: #e6b98a;
  font-weight: 700;
  margin-right: 8px;
  font-size: 5vw;
}

.list {
  padding: 4vw;
}

.list .item {
  background-color: #e4e4e7;
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 20px;
}

</style>
